<template lang='pug'>
  .status-fpu
    span {{ value }}
</template>

<script>

export default {
  props: {
    fpu: { type: Object, required: true }
  },
  computed: {
    value () {
      if (this.fpu) {
        return (this.fpu.value || 1) * (this.fpu.instances || 1)
      }
      return 1
    }
  }
}
</script>

<style lang='less'>
  .status-fpu {
    font-size: 25px;
    font-weight: 200;
    margin: 20px auto;
    padding: 20px;
    position: relative;
    height: 80px;
    width: 80px;
  }
</style>
